export default __webpack_public_path__ + "static/media/48_ice.3b09f2e9.JPG";